import React, { useEffect, useState, useRef } from 'react';

import Modal from 'react-modal';
import { DatePicker } from 'antd';

import {
  exportPickingList,
  fetchCustomerGroups,
  fetchPickingList,
  fetchProcessLocations,
} from '../services/ordersService';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { usePermissions } from '../../../contexts/PermissionsContext';
import Loader, { ButtonLoader } from '../../../components/Loader';
import { printPickingListTable } from '../../../utils/printUtils';
import { showWarningToast } from '../../../utils/toastHelper';
import FileNames from '../../../constants/fileNames';
const { RangePicker } = DatePicker;
const dateFormat = 'YYYY/MM/DD';

const permissionMap = {
  '/fbz-picking-list': 'FBZ_ORDER_SUMMARY',
  '/catering-picking-list': 'CATERING_ORDER_SUMMARY',
};
export default function PickingList() {
  const { t } = useTranslation('Order');
  const location = useLocation();
  const deliveryDateSelectFilter = ['1', '2', '3'];
  const [isOrdersCatering, setIsOrdersCatering] = useState(false);

  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(false);
  const [pickingListData, setPickingListData] = useState({
    customerData: [],
    products: {},
  });
  const productIds = Object.keys(pickingListData.products);
  const [processLocations, setProcessLocations] = useState([]);
  // const [deliveryDateFilter, setDeliveryDateFilter] = useState([]);
  const [dateFilter, setDateFilter] = useState('');

  const [datePickerValue, setDatePickerValue] = useState(null);

  const [customerGroups, setCustomerGroups] = useState([]);

  const [pathName, setPathName] = useState(false);
  const [isPrinting, setIsPrinting] = useState(false);

  const [filters, setFilters] = useState({
    processLocations: [],
    deliveryDateSelectFilter: ['1'],
    customerGroupFilter: [],
  });
  const { permissions } = usePermissions();
  const permissionKey = permissionMap[pathName];
  const resetStates = () => {
    setSearchQuery('');
    setFilters({
      processLocations: [],
      deliveryDateSelectFilter: ['1'],
      customerGroupFilter: [],
    });
  };
  const fetchData = async (ifSearch = 0) => {
    setLoading(true);

    const isCatering = location.pathname === '/catering-picking-list';
    try {
      const query = {
        search: searchQuery,
        type: isCatering ? 'CATERING' : 'FBZ',
        processLocations: filters.processLocations,
        customerGroupFilter: filters.customerGroupFilter,
      };

      // if (deliveryDateFilter.some((date) => date)) {
      //   query.deliveryDateFilter = deliveryDateFilter;
      // } else {
      //   query.deliveryDateSelectFilter = filters.deliveryDateSelectFilter;
      //   // query.deliveryDateSelectFilter = [
      //     //   ...new Set([0, ...filters.deliveryDateSelectFilter]),
      //     // ];
      //   }
      // query.deliveryDateFilter = deliveryDateFilter;
      query.date = dateFilter;
      query.deliveryDateSelectFilter = filters.deliveryDateSelectFilter;
      if (ifSearch) {
        const pickingListResponse = await fetchPickingList(query);
        if (pickingListResponse.picking_list) {
          setPickingListData(pickingListResponse.picking_list);
        }
      } else {
        const [
          pickingListResponse,
          processLocationsResponse,
          customerGroupsResponse,
        ] = await Promise.all([
          fetchPickingList(query),
          fetchProcessLocations(),
          fetchCustomerGroups({
            per_page: 9999,
            category: isCatering ? 'CATERING' : 'FBZ',
          }),
        ]);
        if (pickingListResponse.picking_list) {
          setPickingListData(pickingListResponse.picking_list);
        }

        if (processLocationsResponse.process_locations) {
          setProcessLocations(processLocationsResponse.process_locations);
        }
        if (customerGroupsResponse.success) {
          setCustomerGroups(customerGroupsResponse.customer_groups);
        }
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (location.pathname !== pathName) {
      resetStates();
      setPathName(location.pathname);
    }

    const isCatering = location.pathname === '/catering-picking-list';

    if (isOrdersCatering !== isCatering) {
      setIsOrdersCatering(isCatering);
    }
    fetchData();
  }, [location.pathname]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchData(1);
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
  }, [
    searchQuery,
    filters,
    //  deliveryDateFilter,
    dateFilter,
  ]);

  const clearSelectFilter = (filterType) => {
    setFilters((prev) => {
      if (prev[filterType]?.length > 0) {
        return {
          ...prev,
          [filterType]: [],
        };
      }
      return prev;
    });
  };

  const handleFilterChange = (filterType, value) => {
    if (filterType === 'deliveryDateSelectFilter' && dateFilter) {
      clearDateFilter();
      // showWarningToast(t('PLEASE_CLEAR_DATE_FILTERS_FIRST'));
      // return;
    }

    setFilters((prev) => {
      const newFilterState = { ...prev };
      if (value === 'ALL') {
        if (
          filterTypeData[filterType].length &&
          typeof filterTypeData[filterType][0] === 'object' &&
          'id' in filterTypeData[filterType][0]
        ) {
          newFilterState[filterType] =
            newFilterState[filterType].length ===
            filterTypeData[filterType].length
              ? [] // Deselect all
              : filterTypeData[filterType].map((item) => item.id); // Select all
        } else {
          newFilterState[filterType] =
            newFilterState[filterType].length ===
            filterTypeData[filterType].length
              ? [] // Deselect all
              : [...filterTypeData[filterType]]; // Select all as-is
        }
      } else {
        newFilterState[filterType] = newFilterState[filterType].includes(value)
          ? newFilterState[filterType].filter((item) => item !== value) // Deselect the item
          : [...newFilterState[filterType], value]; // Select the item
      }

      return newFilterState;
    });
  };

  const handleDateFilterChange = (date, dateString) => {
    if (filters.deliveryDateSelectFilter.length !== 0) {
      clearSelectFilter('deliveryDateSelectFilter');
      // showWarningToast(t('PLEASE_CLEAR_DATE_FILTERS_FIRST'));
      // return
    }
    setDateFilter(dateString);
    setDatePickerValue(date);
  };
  const clearDateFilter = () => {
    if (dateFilter !== '') setDateFilter('');
    if (datePickerValue !== null) setDatePickerValue(null);
  };
  const filterTypeData = {
    processLocations: processLocations,
    deliveryDateSelectFilter: deliveryDateSelectFilter,
    customerGroupFilter: customerGroups,
  };
  const isSingleDateSelected = (deliveryDateFilter, dateFilter) => {
    const hasOneDeliveryDate =
      Array.isArray(deliveryDateFilter) && deliveryDateFilter.length === 1;
    const hasDate = dateFilter.trim() !== '';
    return (hasOneDeliveryDate && !hasDate) || (!hasOneDeliveryDate && hasDate);
  };
  const handleExportOrders = async () => {
    if (!isSingleDateSelected(filters.deliveryDateSelectFilter, dateFilter)) {
      showWarningToast(t('PLEASESELECTONLYONEDELIVERYDATE'));
      return;
    }
    const data = {
      search: searchQuery,
      processLocations: filters.processLocations,
      customerGroupFilter: filters.customerGroupFilter,
      type: isOrdersCatering ? 'CATERING' : 'FBZ',
    };
    // if (deliveryDateFilter.some((date) => date)) {
    //   data.deliveryDateFilter = deliveryDateFilter;
    // } else {
    //   data.deliveryDateSelectFilter = filters.deliveryDateSelectFilter;

    //   // data.deliveryDateSelectFilter = [
    //   //   ...new Set([0, ...filters.deliveryDateSelectFilter]),
    //   // ];
    // }
    // data.deliveryDateFilter = deliveryDateFilter;
    data.date = dateFilter;
    data.deliveryDateSelectFilter = filters.deliveryDateSelectFilter;
    const response = await exportPickingList(
      data,
      isOrdersCatering
        ? FileNames.CATERING_PICKING_LIST_EXPORT
        : FileNames.FBZ_PICKING_LIST_EXPORT
    );
  };

  const handlePrint = () => {
    if (!isSingleDateSelected(filters.deliveryDateSelectFilter, dateFilter)) {
      showWarningToast(t('PLEASESELECTONLYONEDELIVERYDATE'));
      return;
    }

    let headers = [
      // [t('DELIVERYDATE')],
      [t('PRODUCTNAME')],
      [t('PRODUCTCODE')],
      [t('PRODUCTREMARK')],
    ];
    let deliveryDateString = dateFilter
      ? `${new Date(dateFilter).toLocaleDateString('en-GB')}`
      : filters.deliveryDateSelectFilter.length > 0
        ? filters.deliveryDateSelectFilter
            .map((days) =>
              new Date(
                Date.now() + days * 24 * 60 * 60 * 1000
              ).toLocaleDateString('en-GB')
            )
            .join(', ')
        : '';
    // headers[0].push(deliveryDateString);
    let customerGroupNames = null;
    if (isOrdersCatering && filters.customerGroupFilter.length > 0) {
      const customerGroupIdSet = new Set(filters.customerGroupFilter);
      customerGroupNames = customerGroups
        .filter((group) => customerGroupIdSet.has(group.id))
        .map((group) => group.group)
        .join(', ');
      // headers.unshift([t('CUSTOMERGROUP'), customerGroupNames]);
    }
    let content = [];

    productIds.map((productId) => {
      let headingStartIndex = 0;
      // if (isOrdersCatering && filters.customerGroupFilter.length>0) {
      //   headingStartIndex=1;
      // }
      headers[headingStartIndex].push(
        pickingListData.products[productId]?.name || ''
      );

      headers[headingStartIndex + 1].push(
        pickingListData.products[productId]?.code || ''
      );
      headers[headingStartIndex + 2].push(
        pickingListData.products[productId]?.product_remarks || ''
      );
    });

    pickingListData.customerData.map((row) => {
      //first cell of the row
      let contentRow = [];
      if (isOrdersCatering) {
        contentRow.push(row.customer?.customer_name || '');
      } else {
        contentRow.push(
          (row.customer?.customer_group || '') +
            '<br>' +
            (row.customer?.contact_name || '')
        );
      }

      productIds.map((productId) => {
        const quantity = row.quantity[productId];
        contentRow.push(
          quantity === 0 || quantity === '0' ? '0' : quantity || ''
        );
      });

      content.push(contentRow);
    });
    //last row
    let contentRow = [t('TOTALQUANTITY')];

    productIds.map((productId) => {
      const totalQuantity = pickingListData.customerData?.reduce(
        (sum, customer) => {
          const quantity = customer.quantity;
          return sum + (quantity[productId] || 0);
        },
        0
      );
      contentRow.push(totalQuantity);
    });
    content.push(contentRow);

    printPickingListTable(
      headers,
      content,
      t('PICKINGLISTS'),
      setIsPrinting,
      customerGroupNames,
      deliveryDateString
    );
  };
  return (
    <main className="">
      <section className="main-section fbz-order filterpicklist">
        <section className="data">
          <div className="data on-responsive-block">
            <div className="row">
              <div className="col-sm-12 col-xl-3 col-md-12">
                <div className="left">
                  <h1>
                    {isOrdersCatering
                      ? t('CATERINGPICKINGLISTS')
                      : t('FBZPICKINGLISTS')}
                  </h1>
                  <div className="d-flex gap-2 search-list align-items-center">
                    <div className="">
                      <div className="input-card my-1">
                        <img src="images/search-icon.svg" alt="" />
                        <input
                          type="text"
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                          placeholder={t('SEARCH')}
                        />
                      </div>
                    </div>
                    <div className="">
                      <p className="mb-0">
                        {/* {t('DELIVERYDATE')}: <span> 29/08/2024</span> */}
                        {t(
                          'DELIVERYDATE'
                        )}:{' '}
                        <span>
                          {dateFilter
                            ? `${new Date(dateFilter).toLocaleDateString('en-GB')}`
                            : ''}

                          {filters.deliveryDateSelectFilter.length > 0
                            ? // ? [0, ...filters.deliveryDateSelectFilter]
                              filters.deliveryDateSelectFilter
                                .map((days) =>
                                  new Date(
                                    Date.now() + days * 24 * 60 * 60 * 1000
                                  ).toLocaleDateString('en-GB')
                                )
                                .join(', ')
                            : ''}
                          {/* //  new Date().toLocaleDateString('en-GB')} */}
                        </span>
                      </p>
                    </div>
                  </div>
                  <div className="filter-section date">
                    <label>{t('DELIVERYDATE')}</label>

                    <div className="date-picker range-picker">
                      <DatePicker
                        onChange={handleDateFilterChange}
                        value={datePickerValue}
                        placeholder={t('SELECTDATE')}
                        format={dateFormat}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-12 col-xl-4 col-sm-12">
                <div className="right">
                  <div className="filter-container ">
                    {pathName === '/catering-picking-list' && (
                      <div className="pro-filter filter-section">
                        <label>{t('CUSTOMERGROUPNAME')}</label>
                        <div className="checkbox-group pro-filter">
                          <label className="custom-checkbox">
                            {t('ALL')}
                            <input
                              type="checkbox"
                              checked={
                                filters.customerGroupFilter?.length ===
                                customerGroups?.length
                              }
                              onChange={() =>
                                handleFilterChange('customerGroupFilter', 'ALL')
                              }
                            />
                            <span className="checkmark"></span>
                          </label>
                          {customerGroups.map((customerGroup) => (
                            <label
                              key={customerGroup.id}
                              className="custom-checkbox"
                            >
                              {customerGroup.group}
                              <input
                                type="checkbox"
                                checked={filters.customerGroupFilter?.includes(
                                  customerGroup.id
                                )}
                                onChange={() =>
                                  handleFilterChange(
                                    'customerGroupFilter',
                                    customerGroup.id
                                  )
                                }
                              />
                              <span className="checkmark"></span>
                            </label>
                          ))}
                        </div>
                      </div>
                    )}
                    {/* <div className="filter-section date">
                    <label>{t('DELIVERYDATE')}</label>
                    <div className={`date-picker range-picker `}>
                      <RangePicker
                        key={pathName}
                        onChange={handleDateFilterChange}
                        separator={'-'}
                        placeholder={[t('FROM'), t('TO')]}
                        // disabled={filters.deliveryDateSelectFilter.length > 0}
                      />
                    </div>
                  </div> */}
                    {/* <div className="filter-section date">
                    <label>{t('DELIVERYDATE')}</label>

                    <div className="date-picker range-picker">
                      <DatePicker
                        onChange={handleDateFilterChange}
                        value={datePickerValue}
                        placeholder={t('SELECTDATE')}
                        format={dateFormat}
                      />
                    </div>
                  </div> */}
                    <div className="filter-section">
                      <label>{t('DELIVERYDATE')}</label>
                      <div className="pro-filter checkbox-group">
                        <label className="custom-checkbox">
                          {t('ALL')}
                          <input
                            type="checkbox"
                            checked={
                              filters.deliveryDateSelectFilter.length ===
                              deliveryDateSelectFilter.length
                            }
                            onChange={() =>
                              handleFilterChange(
                                'deliveryDateSelectFilter',
                                'ALL'
                              )
                            }
                            // disabled={deliveryDateFilter.some((date) => date) > 0}
                          />
                          <span className={`checkmark  `}></span>
                        </label>
                        {deliveryDateSelectFilter.map((day, i) => (
                          <label key={i} className="custom-checkbox">
                            {t('TODAY')} +{day}
                            <input
                              type="checkbox"
                              checked={filters.deliveryDateSelectFilter.includes(
                                day
                              )}
                              onChange={() =>
                                handleFilterChange(
                                  'deliveryDateSelectFilter',
                                  day
                                )
                              }
                              // disabled={
                              //   deliveryDateFilter.some((date) => date) > 0
                              // }
                            />
                            <span className={`checkmark  `}></span>
                          </label>
                        ))}
                      </div>
                    </div>
                    {pathName === '/fbz-picking-list' && (
                      <div className="pro-filter filter-section">
                        <label>{t('PROCESSLOCATION')}</label>
                        <div className="checkbox-group pro-filter">
                          <label className="custom-checkbox">
                            {t('ALL')}
                            <input
                              type="checkbox"
                              checked={
                                filters.processLocations?.length ===
                                processLocations.length
                              }
                              onChange={() =>
                                handleFilterChange('processLocations', 'ALL')
                              }
                            />
                            <span className="checkmark"></span>
                          </label>
                          {processLocations.map((processLocation) => (
                            <label
                              key={processLocation.id}
                              className="custom-checkbox"
                            >
                              {processLocation.name}
                              <input
                                type="checkbox"
                                checked={filters.processLocations?.includes(
                                  processLocation.id
                                )}
                                onChange={() =>
                                  handleFilterChange(
                                    'processLocations',
                                    processLocation.id
                                  )
                                }
                              />
                              <span className="checkmark"></span>
                            </label>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-lg-12 col-xl-5 col-sm-12">
                <div className="right right-change-cs">
                  <div className="filter-container">
                    <div className="button-group">
                      <button
                        disabled={pickingListData.products?.length === 0}
                        className={`${pickingListData.products?.length === 0 ? 'disable-btn' : ''}`}
                        onClick={handleExportOrders}
                      >
                        <img src="images/export.svg" alt="" />
                        {t('EXPORT')}
                      </button>
                      <button
                        disabled={pickingListData.products?.length === 0}
                        className={`${pickingListData.products?.length === 0 ? 'disable-btn' : ''}`}
                        onClick={handlePrint}
                      >
                        {isPrinting ? (
                          <ButtonLoader />
                        ) : (
                          <>
                            <img src="images/print.svg" alt="" />
                            {t('PRINT')}
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <!-- Table start --> */}

        {/* </div> */}

        {/* ---------------------------new table start------------------------ */}
        {loading ? (
          <tr>
            <td colSpan="100%" className="loader-container mt-5">
              <Loader />
            </td>
          </tr>
        ) : (
          <>
            {pickingListData.products?.length === 0 ? (
              <div colSpan="100%" className="text-center py-4">
                {t('NORECORDAVAILABLE')}
              </div>
            ) : (
              <div className="table-outer scroll picklist-table">
                <table className="table">
                  <thead>
                    <tr className="t-heading">
                      <th className="">
                        <h5>
                          {t('PRODUCTNAME')}
                          <img
                            src="images/right-arrow.svg"
                            alt=""
                            className="ps-2"
                          />
                        </h5>
                        {/* <h5>
                          {t('CUSTOMERINFO')}
                          <img
                            src="images/down-arrow-solid.svg"
                            alt=""
                            className="ps-1"
                          />
                        </h5> */}
                      </th>
                      {productIds.map((productId) => (
                        <th key={productId}>
                          <h5>{pickingListData.products[productId]?.name}</h5>
                          {/* <p>{pickingListData.products[productId]?.code}</p>
                          <p>
                            {
                              pickingListData.products[productId]
                                ?.product_remarks
                            }
                          </p> */}
                        </th>
                      ))}
                    </tr>
                    <tr className="t-heading">
                      <th className="">
                        <h5>
                          {t('PRODUCTCODE')}
                          <img
                            src="images/right-arrow.svg"
                            alt=""
                            className="ps-2"
                          />
                        </h5>
                        {/* <h5>
                          {t('CUSTOMERINFO')}
                          <img
                            src="images/down-arrow-solid.svg"
                            alt=""
                            className="ps-1"
                          />
                        </h5> */}
                      </th>
                      {productIds.map((productId) => (
                        <th key={productId}>
                          {/* <h5>{pickingListData.products[productId]?.name}</h5> */}
                          <p>{pickingListData.products[productId]?.code}</p>
                          {/* <p>
                            {
                              pickingListData.products[productId]
                                ?.product_remarks
                            }
                          </p> */}
                        </th>
                      ))}
                    </tr>
                    <tr className="t-heading customer-remark">
                      <th className="">
                        <h5>
                          {t('PRODUCTREMARK')}
                          <img
                            src="images/right-arrow.svg"
                            alt=""
                            className="ps-2"
                          />
                        </h5>
                        <h5>
                          {t('CUSTOMERINFO')}
                          <img
                            src="images/down-arrow-solid.svg"
                            alt=""
                            className="ps-1"
                          />
                        </h5>
                      </th>
                      {productIds.map((productId) => (
                        <th key={productId}>
                          {/* <h5>{pickingListData.products[productId]?.name}</h5>
                          <p>{pickingListData.products[productId]?.code}</p> */}
                          <p>
                            {
                              pickingListData.products[productId]
                                ?.product_remarks
                            }
                          </p>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {pickingListData.customerData.map((row, i) => (
                      <tr key={i}>
                        <td>
                          {isOrdersCatering ? (
                            <>
                              <h5>{row.customer?.customer_name}</h5>
                            </>
                          ) : (
                            <>
                              <h5>{row.customer?.customer_group}</h5>
                              <h5>{row.customer?.contact_name}</h5>
                              {/* <p>#{row.customer?.contact_phone}</p> */}
                            </>
                          )}
                        </td>
                        {productIds.map((productId) => (
                          <td key={productId}>
                            <h5>
                              {row.quantity[productId] === 0 ||
                              row.quantity[productId] === '0'
                                ? '0' //remove 0 if wanna show blank
                                : row.quantity[productId]}
                            </h5>
                          </td>
                        ))}
                      </tr>
                    ))}

                    <tr className="bg-success-subtle">
                      <td>
                        <h5 className="fw-bold text-center">
                          {t('TOTALQUANTITY')}{' '}
                        </h5>
                      </td>

                      {productIds.map((productId) => {
                        const totalQuantity =
                          pickingListData.customerData?.reduce(
                            (sum, customer) => {
                              const quantity = customer.quantity;
                              return sum + (quantity[productId] || 0);
                            },
                            0
                          );

                        return (
                          <td key={productId}>
                            <h5>{totalQuantity}</h5>
                          </td>
                        );
                      })}
                    </tr>
                  </tbody>
                </table>
              </div>
            )}
          </>
        )}
      </section>
    </main>
  );
}
